import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_TOPIC_CLASSIFIER_SERVICE_AUTO_TRIGGER_ENABLED = createFcmDetails(
	'topic_classifier_service_auto_trigger_enabled',
	{
		owner: 'Data Platform',
		context: 'petition_service',
		description: 'Enables automatic addition of AI recommended topics on petitions',
		import: false,
	},
);
